import { tripPlannerScopeKey } from '@luxuryescapes/contract-trip'
import type { TripItineraryData } from 'tripPlanner/api/types'
import type { DegradedSurfaceIdentity } from 'tripPlanner/assistant/api/surfaceSnapshotContract'

export function buildTripPlannerDegradedIdentity({
  chatId,
  itineraryData,
}: {
  chatId: number
  itineraryData: TripItineraryData | undefined
}): DegradedSurfaceIdentity {
  return {
    surface: 'trip_planner',
    surfaceContextScopeKey: tripPlannerScopeKey({ chatId }),
    tripId: itineraryData ? String(itineraryData.tripChatId) : String(chatId),
  }
}
